<template>
  <section class="main-content clearfix">
    <Lefter ref="lefter" @loadData="loadData"></Lefter>
    <div class="right-container clearfix">
      <BreadCrumbs @loadData="loadData"></BreadCrumbs>
      <!-- <div class="tag-list mrg-btm-20" v-if="page === 'Notice'">
        <span class="tag" :class="{'active': categoryId === item.categoryId}" v-for="(item) in navList" :key="item.name" @click="toggleCategory(item)">{{item.name}}{{categoryId}}|{{item.categoryId}}</span>
      </div> -->
      <List ref="list"></List>
    </div>
  </section>
</template>

<script>
import Lefter from './lefter.vue'
import List from './list.vue'
import BreadCrumbs from './breadCrumbs.vue'
import {mapMutations, mapState} from 'vuex'
export default {
  name: '',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['categoryId']),
    ...mapState('rule', ['page', 'getChildrenFn', 'noticeList']),
    // ...mapState('rule', {
    //   navList (state) {
    //     const navList = [].concat(state.leftNavList)
    //     console.log(333, navList)
    //     navList.unshift({
    //       name: '全部',
    //       categoryId: this.categoryId,
    //       ids: []
    //     })
    //     return navList
    //   }
    // }),
    ancestors () {
      // console.log(22234, this.page, this.$store)
      return this.noticeList[0] && this.noticeList[0].ancestors || ['-']
    }
  },
  mounted () {
    // this.$refs.lefter.promiseFn.then(() => {
    //   this.$refs.list.loadData(this.$refs.lefter.list)
    // })
  },
  methods: {
    toggleCategory (item) {
      this.categoryId = item.categoryId
      this.$router.push({
        name: 'Notice',
        query: {
          categoryId: this.categoryId,
          childCategoryId: item.categoryId
        }
      })
      this.$store.commit('updateCategoryId', {
        categoryId: this.$store.state.categoryId,
        childCategoryId: item.categoryId
      })
      this.updateOpenIds({
        openIds: item.ids
      })
      this.loadData()
    },
    loadData () {
      this.$refs.list.pageModal.pageNo = 1
      this.$refs.list.loadData()
    },
    ...mapMutations('rule', ['updatePhrase', 'updateOpenIds'])
  },
  components: {
    Lefter,
    List,
    BreadCrumbs
  }
}
</script>

<style lang="scss" scoped>

.main-content {
  margin: 10px 0;
  position: relative;
  .right-container {
    margin-left: 248px;
    background: #fff;
    padding-left: 30px;
    padding-right: 30px;
    min-height: 495px;
  }
}
.tag-list {
  .tag {
    display: inline-block;
    font-size: 12px;
    color: #222;
    line-height: 26px;
    font-weight: 400;
    background: #F3F4F5;
    border: 1px solid #F3F4F5;
    border-radius: 13px;
    padding: 0 12px;
    margin-right: 10px;
    cursor: pointer;
    min-width: 46px;
    text-align: center;
  }
  .active  {
    border-color: #F10180;
    color: #F10180;
    background: #fff;
  }
}
.descript-container  {
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  font-weight: 400;
  padding: 20px 0;
}
</style>
